export class ConversationRole {
    constructor(permissions) {
        this.permissions = void 0;
        this.permissions = permissions;
    }
}
